import C from "classnames";
import { useRef as E, useState as r, useEffect as R } from "react";
import { scrollWrapper as I, animated as N, animateShow as O, animateUp as j } from "./AnimatedTextScroll.css.js";
import { jsx as S } from "react/jsx-runtime";
function $({
  words: n,
  currIdx: a,
  style: v
}) {
  const l = (n == null ? void 0 : n.length) || 1, m = (a - 1) % l, w = m >= 0 ? m : l + m, o = E(null), [H, h] = r(), [x, b] = r(), [s, p] = r(), [k, z] = r(!1);
  return R(() => {
    const t = new ResizeObserver((i) => {
      var u, W;
      let f = 0;
      s || p(new Array(l).fill(0)), i.forEach((c, A) => {
        p((B) => {
          var y;
          const g = [...B || []];
          return g[A] = ((y = c.contentRect) == null ? void 0 : y.width) || 0, g;
        });
      });
      for (const c of i)
        ((u = c.contentRect) == null ? void 0 : u.width) > f && (f = (W = c.contentRect) == null ? void 0 : W.width);
      b(f);
    });
    Array.from(o.current.children).forEach((i) => {
      t.observe(i);
    });
    const e = getComputedStyle(o.current) || {}, d = parseFloat(e.fontSize || "0");
    return e.lineHeight === "normal" ? h(d * 1.2) : h(parseFloat(e.lineHeight || "0") || d * 1.2), () => t.disconnect();
  }, []), R(() => {
    const t = o.current.closest('[class^="slate-"]');
    t && t.textContent === n.join("") && z(!0);
  }, []), /* @__PURE__ */ S("span", {
    ref: o,
    className: I,
    style: {
      minHeight: H || "auto",
      minWidth: (s == null ? void 0 : s[a]) || x
    },
    children: n.map((t, e) => /* @__PURE__ */ S("span", {
      className: C(N, {
        [O]: a === e,
        [j]: w === e
      }),
      style: {
        ...v,
        minWidth: k ? "100%" : void 0
      },
      children: t
    }, `text-animated-${t}`))
  });
}
export {
  $ as AnimatedTextScroll
};
